import React, {FC} from "react";
import {ReportItemsSearchPanel, ReportPage} from "../../../components";
import {getPageNameByPageId, getUserId} from "../../../utils";
import {ItemReportSearchParamsModel, PageEnum} from "../../../models";
import {searchReportProductionItemsData,} from "../../../serviceBroker/itemsReportApiServiceBroker";

export const ReportProductionItemsDataPage: FC = () => {
    const initialState: ItemReportSearchParamsModel = {Lang: 1, userId: getUserId()};
    return (
        <ReportPage
            InitialState={initialState}
            SearchApi={searchReportProductionItemsData}
            searchHeader={getPageNameByPageId(PageEnum.ReportProductionItemsData)}
            SearchPanel={ReportItemsSearchPanel}
            formId={PageEnum.ReportProductionItemsData}
        />
    );
};
